import React, { FC, useState } from "react";
import OneYear from "./Tabs/OneYear";
import TwoYear from "./Tabs/TwoYear";
import TreeYear from "./Tabs/TreeYear";
import FourYear from "./Tabs/FourYear";
import FiveYear from "./Tabs/FiveYear";
import SixYear from "./Tabs/SixYear";
import SevenYear from "./Tabs/SevenYear";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { Wrapper } from "../styled";

const educationTabs = [
  {
    title: "Первый год",
    component: <OneYear/>,
  },
  {
    title: "Второй год",
    component: <TwoYear/>,
  },
  {
    title: "Третий год",
    component: <TreeYear/>
  },
  {
    title: "Четвертый год",
    component: <FourYear/>
  },
  {
    title: "Пятый год",
    component: <FiveYear/>
  },
  {
    title: "Шестой год",
    component: <SixYear/>
  },
  {
    title: "Седьмой год",
    component: <SevenYear/>
  }
];


const Education: FC = () => {
  const [tab, setTab] = useState(0);

  const handleChangeTab = (event: React.SyntheticEvent, newValue: number) => {
    setTab(newValue);
  };

  return (
    <Wrapper>
      <Tabs
        value={tab}
        onChange={handleChangeTab}
        variant="scrollable"
        scrollButtons="auto"
        aria-label="scrollable auto tabs example"
      >
        {educationTabs.map((tab) => (
          <Tab key={tab.title} label={tab.title} />
        ))}
      </Tabs>
      {educationTabs[tab].component}
    </Wrapper>
  );
};

export default Education;
